import type { HelpdeskCatalogResponse } from "@repo/shared-types/helpdesk";
import { req } from "../../shared/web/client.ts";

export type ExternalSession = {
  userId: string;
  tenantId: string;
  tenantName: string;
  tenantSlug: string;
  connectionId: string;
  kind: "external" | "internal";
  name: string;
  email: string;
};

export const EXTERNAL_SESSION_KEY: readonly string[] = ["external", "session"];

export function externalSession(signal?: AbortSignal): Promise<ExternalSession> {
  return req<ExternalSession>("/api/auth/session", { signal });
}

export function externalCatalog(signal?: AbortSignal): Promise<HelpdeskCatalogResponse> {
  return req<HelpdeskCatalogResponse>("/api/external/helpdesk/catalog", { signal });
}

export function externalIdentity(session: ExternalSession): string {
  return JSON.stringify([session.tenantId, session.userId, session.connectionId]);
}
